export default __webpack_public_path__ + "static/media/carta2.e3f5e00d.png";